// SideModal.jsx
import React from "react";
import "../CSS/SideModal.css";
import { useTheme } from "./ThemeContext";

const SideModal = ({ isOpen, onClose, onExport }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className={`modal-overlay ${isOpen ? "open" : ""}`} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h1>iBlink</h1>
        <hr /> {/* Horizontal line */}
        <a className="menu-item" href="/add">
          Add a New Address
        </a>
        <a className="menu-item" href="/update-user">
          Update User
        </a>
        <a className="menu-item" href="/manage-categories">
          Manage Categories
        </a>
        {onExport && (
          <button
            className="menu-item"
            onClick={onExport}
            style={{
              width: "100%",
              textAlign: "left",
              font: "inherit",
            }}
          >
            Export Addresses
          </button>
        )}
        <div className="theme-toggle-row">
          <span>Dark Mode</span>
          <button
            onClick={toggleTheme}
            aria-label="Toggle dark mode"
            style={{
              width: "44px",
              height: "24px",
              borderRadius: "12px",
              border: "none",
              cursor: "pointer",
              padding: "2px",
              backgroundColor: theme === "dark" ? "#007bff" : "#ccc",
              display: "flex",
              justifyContent: theme === "dark" ? "flex-end" : "flex-start",
              transition: "background-color 0.2s ease",
            }}
          >
            <span
              style={{
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "block",
              }}
            />
          </button>
        </div>
        <div className="version-number">Version 3.2.2</div>{" "}
        {/* Version number */}
      </div>
    </div>
  );
};

export default SideModal;
